import { useState, useEffect } from "react";
import { CountryService } from "../../services/CountryService";
import { Divider } from "primereact/divider";
import { AddPageHeader } from "../Common/Utils";
import NewsTable from "../Common/NewsTable";
import { Link } from "react-router-dom";

const Migrations = () => {
  const [migrations, setMigrations] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService.getMigrations().then((data) => setMigrations(data));
  }, []);

  return (
    <div className="reduce-width">
      {AddPageHeader("Migration laws, regulations, and policies")}
      <Divider align="center">
        <h1>Migration laws, regulations, and policies</h1>
      </Divider>
      <div className="privacy-terms">
        This page gathers a non-exhaustive selection of news on migration laws,
        regulations, and policies. Information is also accessible via a
        dedicated{" "}
        <Link
          to="https://www.linkedin.com/showcase/migration-laws-regulations-and-policies/"
          target="_blank"
          rel="noreferrer"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          LinkedIn page
        </Link>{" "}
        and{" "}
        <Link
          to="/the-consular-newsletter"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          The Consular Newsletter
        </Link>
        . Are you a governmental body interested in highlighting specific
        frameworks? Please feel free to{" "}
        <Link
          to="/contact"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          contact
        </Link>{" "}
        the Center.
      </div>
      <br />
      <NewsTable data={migrations} searchEnabled longDescription />
    </div>
  );
};

export default Migrations;
